import React, { type FC, type PropsWithChildren } from 'react'
import { InfoOutlined } from '@mui/icons-material'
import { Box, type SxProps, type Theme } from '@mui/material'

import { errorMessagesClasses } from '../ErrorMessage'
import { AnchoredPopover } from './AnchoredPopover'
import { Extras } from './Code'
import type { ErrorMessageExtrasProps } from './Props'

const errorPopoverStyle: SxProps<Theme> = { display: 'flex', width: '100%' }
const infoIconStyle: SxProps<Theme> = { m: 'auto' }
const contentWrapperStyle: SxProps<Theme> = { mt: 1, mx: 1 }

export const ErrorPopover: FC<PropsWithChildren<Pick<ErrorMessageExtrasProps, 'error'>>> = ({ error, children }) => (
    <Box className={errorMessagesClasses.popover} sx={errorPopoverStyle}>
        {children}
        <AnchoredPopover
            className={errorMessagesClasses['popover-content']}
            trigger={({ onClick }) => <InfoOutlined className={errorMessagesClasses['popover-button']} sx={infoIconStyle} onClick={onClick} />}
        >
            <Box className={errorMessagesClasses['popover-extras']} sx={contentWrapperStyle}>
                <Extras variant="body2" error={error} />
            </Box>
        </AnchoredPopover>
    </Box>
)
